import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

// Détecter le mode développement
const isDevelopment =
  window.location.port === "3000" || window.location.port === "3001";

// Créer une promesse pour l'initialisation
const i18nInitPromise = i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: "fr", // langue par défaut
    fallbackLng: "en",
    debug: isDevelopment, // Debug en mode développement

    backend: {
      // Utiliser des URLs relatives qui passent par le proxy Vite
      loadPath: "/i18n/locales/{{lng}}.json",
      requestOptions: {
        cache: "no-store",
      },
    },

    interpolation: {
      escapeValue: false, // React fait déjà l'échappement
    },

    react: {
      useSuspense: false,
    },
  });

// Fonction pour attendre l'initialisation
export const waitForI18n = () => i18nInitPromise;

export default i18n;
